<template lang="pug">
  .component-selectize
    .input-group
      input(type="text", :placeholder="placeholder" :id="_uid+'-selectize'")
      .input-group-button(v-if="showAdd")
        .button(@click="$emit('toggleAdd')")
          .fa.fa-plus
</template>

<script>
  import $ from 'jquery'

  require('selectize/dist/js/standalone/selectize.js')


  export default {
    name: "Selectize",
    data() {
      return {
        container: null,
        selectize: null,
      }
    },
    created() {
      this.$nextTick(() => this.loadSelectize())
    },
    methods: {
      loadSelectize() {
        var selectize = $(`#${this._uid}-selectize`)

        // initialize the Selectize control
        selectize.selectize({
          maxItems: this.maxItems,
          valueField: this.valueField,
          labelField: this.labelField,
          searchField: this.searchField,
          items: this.items,
          render: {
            item: (item, escape) => {
              return this.renderTemplate(item, escape);
            },
            option: (item, escape) => {
              return this.optionTemplate(item, escape);
            },
          },
        });

        // fetch the instance asd
        this.selectize = selectize[0].selectize
        this.options.forEach((item) => {
          this.addOption(item)
        })

        if(this.items){
          this.items.forEach((item) => {
            this.selectize.addItem(item, true)
          })
        }

        this.selectize.on('item_add', this.itemAdded)
        this.selectize.on('item_remove', this.itemRemoved)

        if (this.selectedValue) {
          this.selectize.setValue(this.selectedValue)
        }
        if (this.value) {
          this.selectize.setValue(this.value)
        }
        /**
         * cleanup
         * disponibilità veicolo
         * cambio slot id
         * force resend
         *
         * sotto transazione
         */
      },
      itemAdded(value) {
        // https://github.com/selectize/selectize.js/issues/1085#issuecomment-360077260
        this.$emit('itemAdded', this.selectize.sifter.items[value])
      },
      itemRemoved(value) {
        this.$emit('itemRemoved', this.selectize.sifter.items[value])
      },
      clearOptions() {
        this.selectize.clearOptions()
      },
      clearSelected() {
        this.selectize.clear()
      },
      addOption(option) {
        this.selectize.addOption(option)
      }
    },
    computed: {},
    props: {
      maxItems: {
        type: Number,
        default: null
      },
      options: {
        type: Array,
        required: true
      },
      valueField: {
        type: String,
        default: function () {
          return 'name'
        }
      },
      labelField: {
        type: String,
        default: function () {
          return 'name'
        }
      },
      // default values
      items: {
        type: Array,
      },

      // which fields are available for search. as default value all object keys
      searchField: {
        type: Array,
        default() {
          var fields = []
          for (var key in this.options) {
            fields = Object.keys(this.options[key])
            break
          }
          return fields
        }
      },
      // template for available options
      optionTemplate: {
        type: Function,
        default: function (item, escape) {
          return `<div>${item.name}</div>`
        },
      },
      // template for selected values
      renderTemplate: {
        type: Function,
        default: function (item, escape) {
          return `<div>${item.name}</div>`
        }
      },
      placeholder: {
        type: String
      },
      selectedValue: {

      },
      disabled: {
        type: Boolean
      },
      showAdd: {
        type: Boolean
      },
      value:{}
    },
    watch: {
      disabled: function () {
        this.disabled ? this.selectize.disable() : this.selectize.enable()
      },
      value: function (v) {
        if (v && this.selectize) {
          this.selectize.setValue(v)
        }
      }
    },
  }
</script>

<style lang="sass">
  @import "~selectize/dist/css/selectize.default.css"
  .component-selectize
    .selectize-control
      width: 100%
    .selectize-control.multi .selectize-input.has-items
      padding: 0
    .selectize-input
      padding: 5px
      padding-top: 2px
      padding-bottom: 2px
</style>



// WEBPACK FOOTER //
// Selectize.vue?4e413f1b